module.exports = __webpack_public_path__ + "img/loosing-money.f7b3946f.png";